var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "creategroup"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('legend', [_vm._v("Bag Summary Details")]), _vm._v(" "), _c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Bag No's ")]), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bagno),
      expression: "bagno"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('bagno')
    },
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "name": "bagno",
      "id": "bagno",
      "placeholder": "Enter Bag No's, Use Comma For Multiple Bags"
    },
    domProps: {
      "value": (_vm.bagno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bagno = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('bagno')),
      expression: "errors.has('bagno')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('bagno')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "creategroupfooter form-actions pull-left"
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Clear")])])])])], 1)])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38902b2d","hasScoped":true}!./src/views/components/MarkBagInvalid/MarkBagInvalid_component.html
// module id = 1090
// module chunks = 2